export function RouteLoadingFallback() {
  console.log('[RouteLoadingFallback] rendering null fallback');
  return null;
}
